import {
    ORDER,
    ORDER_SUCCESS,
    ORDER_FAIL,
    CLEAR_REQUEST,
    SINGLE_ORDER_SUCCESS,
    SINGLE_ORDER_FAIL,
    INITIATE_PRODUCT_RETURN_SUCCESS,
    INITIATE_PRODUCT_RETURN_FAIL,
    INITIATE_PRODUCT_RETURN,
} from '../actionTypes';

const initialState = {
    loading: false,
    orders: [],
    order: null,
    loadingProductReturn: false,
};

export const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case ORDER:
            return { ...state, loading: true, error: null, productReturn: null };
        case ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                orders: action.payload,
                error: null,
                productReturn: null,
            };
        case SINGLE_ORDER_SUCCESS:
            return { ...state, loading: false, order: action.payload, error: null };
        case ORDER_FAIL:
            return { ...state, loading: false, error: action.payload };
        case SINGLE_ORDER_FAIL:
            return { ...state, loading: false, singleOrderError: action.payload };
        case INITIATE_PRODUCT_RETURN:
            return { ...state, loadingProductReturn: true, error: null };
        case INITIATE_PRODUCT_RETURN_SUCCESS:
            return {
                ...state,
                loadingProductReturn: false,
                productReturn: action.payload,
                error: null,
            };
        case INITIATE_PRODUCT_RETURN_FAIL:
            return { ...state, loadingProductReturn: false, error: action.error };
        case CLEAR_REQUEST:
            return {};
        default:
            return state;
    }
};
